import { render, staticRenderFns } from "./AdSetting.vue?vue&type=template&id=53b505f1&"
import script from "./AdSetting.vue?vue&type=script&lang=js&"
export * from "./AdSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports